"use client"

import { t } from "@/languages/i18n"
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Space, Typography } from "antd"
import React, { useState } from "react"
import { DatePublish, StatusPublish, VisibilityPublish } from "./StatusPublishContactForm"

const { Title } = Typography

interface ContactPublishProps {
  onSubmit: () => void
  status: string
  setStatus: (status: string) => void
  loading?: boolean
  isEditMode?: boolean
}

const Publish: React.FC<ContactPublishProps> = ({
  onSubmit,
  status,
  setStatus,
  loading,
  isEditMode,
}) => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5 bg-white overflow-hidden shadow-sm">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0 text-base font-semibold">
          {t("Xuất bản")}
        </Title>
        <Button
          onClick={() => setIsVisible(!isVisible)}
          icon={isVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4 w-full" size="middle">
            <StatusPublish status={status} setStatus={setStatus} />
            <VisibilityPublish status={status} />
            <DatePublish />
          </Space>

          <div className="flex justify-end border-t pt-3 px-4 bg-[#f6f7f7] rounded-b-[10px] h-14">
            <Button 
              type="primary" 
              onClick={onSubmit} 
              loading={loading}
            >
              {status === "Draft" 
                ? t("Lưu nháp") 
                : isEditMode ? t("Cập nhật") : t("Xuất bản")
              }
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Publish